import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/components/theme-provider";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/portal/ProtectedRoute";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import InvestorLogin from "./pages/InvestorLogin";
import GisLogin from "./pages/GisLogin";
import PublicGis from "./pages/PublicGis";
import InvestorDashboard from "./pages/InvestorDashboard";
import GisDashboard from "./pages/GisDashboard";
import InvestorGis from "./pages/InvestorGis";
import Services from "./pages/Services";
import Features from "./pages/Features";
import Pricing from "./pages/Pricing";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";


const queryClient = new QueryClient();

const App = () => (
  <ThemeProvider defaultTheme="light">
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/features" element={<Features />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/contact" element={<Contact />} />
              {/* Anonymous Public GIS — no login required to view publicly disclosed layers (P9C) */}
              <Route path="/gis" element={<PublicGis />} />
              <Route path="/investor-login" element={<InvestorLogin />} />
              {/* Authenticated GIS analyst/investor login remains separate */}
              <Route path="/gis-login" element={<GisLogin />} />
              {/* Public password recovery — must remain accessible signed-out */}
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />

              <Route
                path="/investor/dashboard"
                element={
                  <ProtectedRoute requiredRole="investor" loginPath="/investor-login">
                    <InvestorDashboard />
                  </ProtectedRoute>
                }
              />
              {/* Authenticated Investor GIS (P9E) — distinct from anonymous /gis and the
                  GIS Analyst /gis/dashboard. Signing in grants nothing: the page shows
                  only what GET /api/gis/investor/me/layers authorizes. */}
              <Route
                path="/investor/gis"
                element={
                  <ProtectedRoute requiredRole="investor" loginPath="/investor-login">
                    <InvestorGis />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/gis/dashboard"
                element={
                  <ProtectedRoute requiredRole="gis-analyst" loginPath="/gis-login">
                    <GisDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ThemeProvider>
);

export default App;
